/*
 * 1-Minute Maths
 * Copyright © 2021 - 2022 White Rose Maths
 * VerticalFrames.tsx - Simple component for laying out ten frames vertically.
 */

import { PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

const VerticalFrames = ({ children }: PropsWithChildren<unknown>) => {
  return <View style={[styles.verticalFrames, { transform: [{ 'rotate': '-90deg' }] }]}>
    {children}
  </View>;
};

export default VerticalFrames;

const styles = StyleSheet.create({
  verticalFrames: {
    display: 'flex',
    alignSelf: 'center',
    alignContent: 'center',
    justifyContent: 'center'
  },
});
